<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-20">
      <!-- begin col-8 -->
      <div class="col-sm-6 col-xl-7">
        <!-- begin widget-chart -->
        <div
          class="widget widget-rounded m-b-30"
          v-bind:class="{ 'inverse-mode': inverseMode }"
        >
          <!-- begin widget-header -->
          <div class="widget-header">
            <h4 class="widget-header-title ts-flex ts-justify-between">
              <div
                class="ts-flexts-justify-content-start"
                :class="{ 'ts-text-gray-700': !inverseMode }"
              >
                <strong>
                  {{ $t('dashboardcomponents.saleItemsTopByUnitsSold') }}
                </strong>
              </div>
              <div class="ts-flex ts-justify-content-end">
                <select
                  v-model="selectedFilter"
                  @change="fetchData"
                  style="width: 110px"
                  class="filter mr-2"
                  :class="{ 'filter-dark': inverseMode }"
                >
                  <option
                    v-for="(filter, filterKey) in filters"
                    :value="filterKey"
                    :key="filterKey"
                  >
                    {{ filter }}
                  </option>
                </select>
                <a-range-picker
                  style="width: 300px"
                  v-model="rangeDate"
                  :ranges="{
                    Today: [moment(), moment()],
                    'This Month': [
                      moment().startOf('month'),
                      moment().endOf('month')
                    ]
                  }"
                  format="DD-MM-YYYY"
                />
              </div>
            </h4>
          </div>
          <!-- end widget-header -->
          <!-- begin vertical-box -->
          <ts-loading-banner :loading="loading">
            <div class="vertical-box with-grid with-border-top">
              <!-- begin vertical-box-column -->
              <div class="vertical-box-column widget-chart-content">
                <div class="nv-stacked-area-chart height-full">
                  <p class="p-2">
                    {{
                      $t(
                        'dashboardcomponents.stackedAreaChartsShowsTheQuantitiesOfTheTotalSaleItemsBasedOnTheSelectedPeriodOfDatesByBranchOrCompany'
                      )
                    }}
                  </p>
                  <vn-stacked-area
                    :model="datasets"
                    yFormat=",.0f"
                    :height="stackedAreaChart.height"
                    :xFormat="formatDate"
                    :clipEdge="stackedAreaChart.clipEdge"
                    :rightAlignYAxis="stackedAreaChart.rightAlignYAxis"
                    :showControls="stackedAreaChart.showControls"
                  >
                  </vn-stacked-area>
                </div>
              </div>
              <!-- end vertical-box-column -->
              <!-- begin vertical-box-column -->
              <div class="vertical-box-column" style="width: 30%">
                <p class="p-2">
                  {{
                    $t(
                      'dashboardcomponents.polArareaChartsShowsTheTopTenSaleItemsBasedOnTheSelectedCategories'
                    )
                  }}
                </p>
                <polar-area-chart
                  :data="{
                    labels: labels,
                    datasets: polarAreaChartDatasets
                  }"
                  :options="options"
                  class="height-sm"
                ></polar-area-chart>
              </div>
              <!-- end vertical-box-column -->
            </div>
          </ts-loading-banner>
          <!-- end vertical-box -->
        </div>
        <!-- end widget-chart -->
      </div>
      <!-- end col-8 -->
      <!-- begin col-4 -->
      <div class="col-sm-6 col-xl-5">
        <!-- begin card -->
        <div class="card border-0" :class="{ 'bg-dark': inverseMode }">
          <ts-loading-banner :loading="loading">
            <div class="card-body" style="padding: 5px 10px">
              <div class="ts-flex ts-justify-between">
                <div
                  class="ts-flexts-justify-content-start"
                  :class="{ 'ts-text-gray-700': !inverseMode }"
                >
                  <strong>
                    {{ $t('dashboardcomponents.totalIncomeFromSale') }}</strong
                  >
                  <span class="ml-2"
                    ><i
                      class="far fa-question-circle"
                      title="Top products with units sold"
                      v-b-popover.hover="
                        'Products with the most individual units sold. Includes orders from all sales channels.'
                      "
                    ></i
                  ></span>
                </div>
                <div class="ts-flex ts-justify-content-end">
                  <select
                    class="filter"
                    :class="{ 'filter-dark': inverseMode }"
                    v-model="selected"
                    @change="fetchData"
                  >
                    <option
                      v-for="(filter, filterKey) in optionFilters"
                      :value="filterKey"
                      :key="filterKey"
                    >
                      {{ filter }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body p-0">
              <div>
                <div
                  class="widget-chart-full-width ts-px-4"
                  :class="
                    inverseMode
                      ? 'nvd3-inverse-mode'
                      : 'widget-chart-content text-grey'
                  "
                  style="min-height: 355px"
                >
                  <p>
                    {{
                      $t(
                        'dashboardcomponents.stackedAreaChartsShowsTheStatisticsOfTotalIncomefromSaleItemsBasedOnTheSelectedPeriodOfDatesAndcategoriesDayWeekMonthYear'
                      )
                    }}
                  </p>
                  <vn-stacked-area
                    v-if="selected == 'inv_date'"
                    :model="incomeFromSaleDatasets"
                    yFormat=",.2f"
                    :xFormat="formatDate"
                    :clipEdge="areaChart.clipEdge"
                    :rightAlignYAxis="areaChart.rightAlignYAxis"
                    :showControls="areaChart.showControls"
                    style="min-height: 355px; height: 329px"
                  ></vn-stacked-area>
                  <bar-chart
                    v-else
                    :data="{
                      labels: incomeFromSaleLabels,
                      datasets: incomeFromSaleBarChartDatasets
                    }"
                    :options="options"
                    class="height-sm"
                    style="min-height: 355px; height: 329px"
                  ></bar-chart>
                </div>
              </div>
            </div>
          </ts-loading-banner>
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import PolarAreaChart from '@/components/vue-chartjs/PolarAreaChart'
import BarChart from '@/components/vue-chartjs/BarChart'
import { keys, map } from 'lodash'
export default {
  components: {
    PolarAreaChart,
    BarChart
  },
  props: ['inverseMode'],
  data() {
    return {
      filters: {
        company_name: 'Company',
        branch: 'Branch'
      },
      optionFilters: {
        inv_date: 'Day',
        inv_date_by_week: 'Week',
        inv_date_by_month: 'Month',
        inv_date_by_year: 'Year'
      },
      loading: false,
      selectedFilter: '',
      selected: '',
      rangeDate: [moment().add(-3, 'Month'), moment()],
      // stacked Area Chart
      saleItemsByDate: [],
      stackedAreaChart: {
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: false,
        height: '350px'
      },
      // polar Area Chart
      saleItemsTop10: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: 20
        }
      },
      incomeFromSale: [],
      areaChart: {
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: false
      }
    }
  },
  computed: {
    // polar Area Chart
    labels() {
      return keys(this.saleItemsTop10)
    },
    polarAreaChartDatasets() {
      return [
        {
          borderWidth: 2,
          borderColor: [
            '#727cb6',
            '#348fe2',
            '#ffc107',
            '#b6c2c9',
            '#00acac',
            '#2d353c',
            '#ff5b57',
            '#6610f2',
            '#fd7e14',
            '#e83e8c'
          ],
          backgroundColor: [
            'rgba(114, 124, 182, 0.5)',
            'rgba(52, 143, 226, 0.5)',
            'rgba(255, 193, 7, 0.5)',
            'rgba(182, 194, 201, 0.5)',
            'rgba(0, 172, 172, 0.5)',
            'rgba(45, 53, 60, 0.5)',
            'rgba(255, 91, 87, 0.5)',
            'rgba(102, 16, 242, 0.5)',
            'rgba(253, 126, 20, 0.5)',
            'rgba(232, 62, 140, 0.5)'
          ],
          data: map(this.saleItemsTop10, r => {
            return r.amount
          })
        }
      ]
    },
    // vn-stacked-area chart
    datasets() {
      return [
        {
          key: 'Quantity',
          color: '#f59c1a',
          values: map(this.saleItemsByDate, (item, key) => {
            return { x: Date.parse(key), y: item.quantity }
          })
        }
      ]
    },
    incomeFromSaleDatasets() {
      return [
        {
          key: 'Total Amount Paid',
          color: '#348fe2',
          values: map(this.incomeFromSale, item => {
            return {
              x: new Date(item.date).getTime(),
              y: item.total_amount_paid
            }
          })
        }
      ]
    },
    incomeFromSaleBarChartDatasets() {
      return [
        {
          label: 'Total Amount Paid',
          borderColor: '#348fe2',
          backgroundColor: 'rgba(52, 143, 226, 0.7)',
          borderWidth: 2,
          data: map(this.incomeFromSale, r => {
            return r.total_amount_paid
          })
        }
      ]
    },
    incomeFromSaleLabels() {
      return map(this.incomeFromSale, item => {
        return item.date
      })
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]
    this.selected = Object.keys(this.optionFilters)[0]

    this.fetchData()
  },
  methods: {
    moment,
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchSaleItem', {
          group_by: this.selectedFilter,
          inv_date_by: this.selected,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          this.incomeFromSale = responses.incomeFromSale
          this.saleItemsByDate = responses.saleItemsByDate
          for (var propName in responses.saleItemsTop10) {
            if (responses.saleItemsTop10.hasOwnProperty(propName)) {
              this.saleItemsTop10 = responses.saleItemsTop10[propName]
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    formatDate(d) {
      // eslint-disable-next-line
      return d3.time.format('%x')(new Date(d))
    }
  },

  watch: {
    rangeDate: function() {
      this.fetchData()
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
